import styled from 'styled-components';
import BgImage from 'common/assets/image/saasModern/map.png';

const PartnerSectionWrapper = styled.section`
  padding: 120px 0;
  background-color: #b1ceff80;
  background-image: url(${BgImage});
  background-repeat: no-repeat;
  background-position: 25% center;

  @media (max-width: 990px) {
    padding: 100px 0;
  }
  @media (max-width: 767px) {
    padding: 80px 0;
  }
  @media (max-width: 575px) {
    padding: 60px 0;
  }

  a {
    color: #46679f;
    text-decoration: underline;
  }

  /* On a phone the heading stays above the photo, so a jump to #team lands on
     it instead of on the picture. */
  @media (max-width: 767px) {
    .team_text {
      display: contents;
    }
    .team_text > :first-child {
      order: -1;
      width: 100%;
      padding: 0 15px;
    }
    .team_image {
      order: 0;
    }
    .team_text > :not(:first-child) {
      order: 1;
      width: 100%;
      padding: 0 15px;
    }
  }
`;

export default PartnerSectionWrapper;
